import { Box, Button, Divider, HStack, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import Selector from '../../components/Selector/Selector'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'
const ammount = '@nMonto'
const month = '@nMes'

const calculateTexts = (haveAmmount, haveMonth, title = '') => {
  if (haveAmmount) {
    return title.split(ammount)
  }
  if (haveMonth) {
    return title.split(month)
  }

  return [title]
}
const formatOption = (element) => {
  if (element) {
    return {
      id: element.idOpcionVariableAlerta,
      label: element.sOpcion,
      value: element.sOpcion,
      ...element,
    }
  }
  return null
}
const formatOptions = (initial = []) => {
  return initial.map(formatOption)
}
const inProgres = 'Solicitud en proceso'
const inactive = 'Activar alerta'
const active = 'Desactivar alerta'
const labels = {
  SDS: inProgres,
  SAC: inProgres,
  DS: inactive,
  AC: active,
}

const variants = {
  SDS: 'gray500',
  SAC: 'gray500',
  DS: 'primary',
  AC: 'black',
}

const SendButton = ({ sEstado, onClick }) => {
  const label = labels[sEstado] || labels.DS
  return (
    <Button variant={variants[sEstado]} borderRadius="24px" onClick={onClick}>
      <Text variant="subtitle2" color="white">
        {label}
      </Text>
    </Button>
  )
}

SendButton.propTypes = {
  onClick: PropTypes.func,
  sEstado: PropTypes.string,
}

const Component = ({ title = '', alert, baseAlert, fetchActiveAlerts }) => {
  const [value, setValue] = useState(
    formatOption(
      baseAlert?.lVariables[0]?.lOpciones.find(
        (element) => element.sOpcion === alert.activeAlert?.sOpcion,
      ),
    ),
  )
  const haveAmmount = title.includes(ammount)
  const haveMonth = title.includes(month)
  const labels = calculateTexts(haveAmmount, haveMonth, title)
  const options = formatOptions(alert?.lVariables[0]?.lOpciones)
  const onChange = (id) => {
    const optionSelected = options.find((element) => element.id === id)

    setValue(optionSelected)
  }

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const onOkStatus = useCallback(
    (message, status) => {
      handleCLoseLoading()
      handleSetTitle(message, status)
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          {status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpen()
    },
    [handleCLoseLoading, handleChangeBody, handleOpen, handleSetTitle],
  )

  const sendRequest = async () => {
    if (!alert.activeAlert || !alert.activeAlert?.sEstado) {
      handleOpenLoading()
      const body =
        baseAlert.lVariables.length > 0
          ? {
              idAlerta: baseAlert.idAlerta,
              idOpcionVariableAlerta: value.idOpcionVariableAlerta,
            }
          : { idAlerta: baseAlert.idAlerta }
      REPOSITORY.wsEmpresa.company
        .configureAlert(body)
        .then((res) => {
          handleCLoseLoading()
          onOkStatus('Activación realizada con éxito.', res.status)
          fetchActiveAlerts()
        })
        .catch(() => {
          handleCLoseLoading()
          onOkStatus('Error al activar alerta.', 500)
        })
    } else if (alert.activeAlert.sEstado) {
      handleOpenLoading()
      const newStatus = alert.activeAlert.sEstado === 'AC' ? 'DS' : 'AC'
      const statusLabel =
        alert.activeAlert.sEstado === 'AC' ? 'Desactivación' : 'Activación'
      const errorLabel =
        alert.activeAlert.sEstado === 'AC' ? 'desactivar' : 'activar'
      REPOSITORY.wsEmpresa.company
        .updateAlert({
          idAlertaEmpresa: alert.activeAlert.idAlertaEmpresa,
          sEstado: alert.activeAlert.sEstado,
          sNuevoEstado: newStatus,
        })
        .then((res) => {
          handleCLoseLoading()
          onOkStatus(`${statusLabel} realizada con éxito.`, res.status)
          fetchActiveAlerts()
        })
        .catch(() => {
          handleCLoseLoading()
          onOkStatus(`Error al ${errorLabel} alerta.`, 500)
        })
    }
  }

  return (
    <>
      <HStack h="100px" w="100%" justifyContent={'space-between'}>
        <HStack minW="70%" wrap={'nowrap'}>
          {labels.map((element, index) => {
            {
              if (index === 0 && labels.length - 1 > index)
                return (
                  <HStack key={element}>
                    <Text variant="body1" color="black" fontWeight="bold">
                      {element}
                    </Text>
                    <Box>
                      <Selector
                        disabled={
                          !['DS', null, undefined].includes(
                            alert?.activeAlert?.sEstado,
                          )
                        }
                        defaultValue={!value ? options?.[0] : value}
                        options={options}
                        onChange={onChange}
                      />
                    </Box>
                  </HStack>
                )
              return (
                <Text key={element} color="black" fontWeight="bold">
                  {element}
                </Text>
              )
            }
          })}
        </HStack>
        <Box>
          <SendButton
            sEstado={alert?.activeAlert?.sEstado}
            onClick={sendRequest}
          />
        </Box>
      </HStack>
    </>
  )
}

Component.propTypes = {
  alert: PropTypes.object,
  alertId: PropTypes.number,
  baseAlert: PropTypes.object,
  fetchActiveAlerts: PropTypes.func,
  handleOpenConfirmation: PropTypes.func,
  title: PropTypes.string,
}
export default function Alert({
  index,
  alertId,
  title,
  handleOpenConfirmation,
  baseAlert,
  fetchActiveAlerts,
  ...rest
}) {
  const componentProps = {
    title,
    handleOpenConfirmation,
    alertId,
    baseAlert,
    fetchActiveAlerts,
    alert: rest,
  }
  if (index === 0) return <Component {...componentProps} />

  return (
    <>
      <Divider />
      <Component {...componentProps} />
    </>
  )
}

Alert.propTypes = {
  alertId: PropTypes.number,
  baseAlert: PropTypes.object,
  fetchActiveAlerts: PropTypes.func,
  handleOpenConfirmation: PropTypes.func,
  index: PropTypes.number,
  lenght: PropTypes.number,
  title: PropTypes.string,
}
